import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Repeat from '../../System/Schedule/Components/Repeat';

export default class Holiday_DOW_Settings extends Component {
	constructor(props) {
		super(props);

		let holiday_info = this.props.param.holiday_info; //contains all the tenant information
		if (Object.keys(holiday_info).length === 0) { //Check for empty object
			holiday_info.dow = [];
			holiday_info.calendar = { date: {}, dow: {} };
		}

		let days_of_week = [
			{
				key: 0,
				display: this.props.receiver.getString('s_sun'),
				is_checked: holiday_info.dow.includes(0) ? true : false,
			},
			{
				key: 1,
				display: this.props.receiver.getString('s_mon'),
				is_checked: holiday_info.dow.includes(1) ? true : false,
			},
			{
				key: 2,
				display: this.props.receiver.getString('s_tue'),
				is_checked: holiday_info.dow.includes(2) ? true : false,
			},
			{
				key: 3,
				display: this.props.receiver.getString('s_wed'),
				is_checked: holiday_info.dow.includes(3) ? true : false,
			},
			{
				key: 4,
				display: this.props.receiver.getString('s_thu'),
				is_checked: holiday_info.dow.includes(4) ? true : false,
			},
			{
				key: 5,
				display: this.props.receiver.getString('s_fri'),
				is_checked: holiday_info.dow.includes(5) ? true : false,
			},
			{
				key: 6,
				display: this.props.receiver.getString('s_sat'),
				is_checked: holiday_info.dow.includes(6) ? true : false,
			}
		];

		this.holiday_info = holiday_info;
		this.state = {
			days_of_week: days_of_week,
		}
	}

	handleChangeDaysOfWeek = (key) => {
		let list = [...this.state.days_of_week];
		for (let i in list) {
			if (list[i].key == key) {
				list[i].is_checked = !list[i].is_checked;
				this.setState({
					days_of_week: list,
				});
				break;
			}
		}
	}

	rcvLoadPriceInfo = (price_info) => {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Unit_Price_Settings', { price_info: price_info == null ? {} : price_info });
	}

	handlePrevious = () => {
		window.app.showLoading();
		this.props.receiver.loadPriceInfo();
	}

	// Save holiday information
	handleRegister = () => {

		let dow = [];
		for (let j in this.state.days_of_week) {
			if (this.state.days_of_week[j].is_checked) {
				dow.push(this.state.days_of_week[j].key);
			}
		}

		this.holiday_info.dow = dow;
		this.props.receiver.saveHolidayCalendar(this.holiday_info);
	}

	rcvSaveHolidayCalendar = (response) => {
		if (response != null && response.result == 'OK') {
			this.handlePrevious();
		}
	}

	render() {

		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString("dow")}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ marginTop: 20, marginBottom: 20 }}>
						<Repeat
							receiver={this.props.receiver}
							days_of_week={this.state.days_of_week}
							handleChangeDaysOfWeek={this.handleChangeDaysOfWeek}
							repeatKeyword={'holiday'}
						/>
					</div>
				</div>
			</div>
		)
	}
}